import { applyDefaultCreated } from "../stock/services/config";
import { admin, db } from "../common/config/Firebase";
import { isOfflineMode } from "../common/services/util";

export const SET_STOCK_DATA = 'SET_STOCK_DATA';
export const SET_STOCK = 'SET_STOCK';
export const DELETE_STOCK = 'DELETE_STOCK'
export const SET_STOCK_LOADING = 'SET_STOCK_LOADING'

const setStockData = payload => (
    { type: SET_STOCK_DATA, payload }
)

const setStock = payload => (
    { type: SET_STOCK, payload }
)

const deleteStockData = payload => (
    { type: DELETE_STOCK, payload }
)

const setStockLoading = payload => (
    { type: SET_STOCK_LOADING, payload }
)

export const flagLoading = loading => {
    return dispatch => {
        dispatch(setStockLoading({ loading }));
    }
}

const collectionStock = db.collection('stock')
const collectionParams = db.collection('params')

export const addStock = ({ data, resolve, reject }) => {
    return dispatch => {
        if (isOfflineMode) {
            resolve();
        }

        addStock2(data).then(() => resolve())
    }
}

export const addStock2 = async data => {
    let stockParam = await collectionParams.doc('stock').get()

    applyDefaultCreated(data, stockParam.data() ? stockParam.data().count : 0);
    const increment = admin.firestore.FieldValue.increment(1);
    await collectionParams.doc('stock').update({count: increment});
    await collectionStock.add(data)
}

export const getStock = payload => {
    return (dispatch, getState) => {
        dispatch(setStockLoading({ loading: true }));

        collectionStock.onSnapshot(snapshot => {
            let dataAdd = {};
            let dataUpdate = {};
            let dataDelete = {};
            
            snapshot.docChanges().forEach(change => {
                
                if (change.type === "added") {
                    dataAdd[change.doc.id] = adaptStockData(change.doc.data());
                } else if (change.type === "modified") {
                    dataUpdate[change.doc.id] = adaptStockData(change.doc.data());
                } else if (change.type === "removed") {
                    dataDelete[change.doc.id] = adaptStockData(change.doc.data());
                }
            });

            if (getState().stock.data.length === 0) {
                dispatch(setStockData(dataAdd))
            } else {
                Object.entries(dataAdd).forEach(([key, value]) => dispatch(setStock({stock: key, data: value})));
                Object.entries(dataUpdate).forEach(([key, value]) => dispatch(setStock({stock: key, data: value})));
                Object.entries(dataDelete).forEach(([key, value]) => dispatch(deleteStockData({stock: key })));
            }
        }
    )
    }
}

const adaptStockData = data => {
    const des = data.description ? String(data.description).split(" ") : [""]
    const brand = data.brand || ""
    const model = data.model ? String(data.model).split("/") : [""]
    const arrayBrandModel = model.map(m => brand + " " + m) //.flat().join(" ")

    let search = []
    des.forEach(d => {
        arrayBrandModel.forEach(abm => {
            search.push(d + " " + abm)
        })
    })
    search = search.flat().join(" ").replace(/\s+/g, ' ').trim()

    return {...data, search }
}

export const updateStock = ({ data, oldStock, resolve}) => {
    return dispatch => {
        updateStock2(data).then(() => resolve())
    }
}

export const updateStock2 = async data => {
    data.lastUpdated = new Date().getTime();
    await collectionStock.doc(data.id).set(data)
}

export const updateStockImport = async data => {
    data.lastUpdated = new Date().getTime();

    const count = admin.firestore.FieldValue.increment(data.count);
    await collectionStock.doc(data.id).update({ count })
}

export const deleteStock = ({ data, resolve }) => {
    return dispatch => collectionStock.doc(data.id).delete().then(() => resolve())
}
